import { gql } from '@moonpig/web-core-graphql'

export const GetRecentlyViewedProductsGQL = gql`
  query GetRecentlyViewedProducts($productIds: [String]) {
    productLookup(productIds: $productIds) {
      products {
        id
        title
        category {
          id
          name
          department
        }
        isFavourited
        masterVariant {
          title
          price {
            currencyCode
            centAmount
          }
          inStock
          productImages {
            mainImage {
              medium {
                jpgUrl
              }
            }
            images {
              small {
                jpgUrl
              }
              medium {
                jpgUrl
              }
              large {
                jpgUrl
              }
            }
          }
        }
      }
    }
  }
`
